export default {
  priceChanged: 'Ceci a modifié votre prix pour celui-ci:',
  changeAnswer: 'Modifier votre réponse',
};
